

$(window).on("load", function () {
    var swiper = new Swiper(".mySwiper", {
        effect: "coverflow",
        grabCursor: true,
 
        slidesPerView: 1,
        loop: true,
        coverflowEffect: {
            rotate: 0,
            stretch: 600,
            depth: 500,
            modifier: 1,
            scale: 1.1,
            slideShadows: false,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 3
            }   
        }
    });
});
